import ErrorToast from '@components/ErrorToast';
import * as constants from '@constants';
import {
  purchaseOrderProductsGet as purchaseOrderStylesGet,
  salesOrderProductsGet as salesOrderStylesGet,
} from '@services/api/cascade-tracing-service';
import { useEffect, useState } from 'react';
import useToast from '@/hooks/useToast';

export default function useProducts(orderType) {
  const { toast } = useToast();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts =
      orderType === constants.TRACE_TYPE_ENUM.PURCHASE_ORDER
        ? purchaseOrderStylesGet
        : salesOrderStylesGet;

    fetchProducts().then(response => {
      if (response.status >= 400) {
        toast.custom(t => <ErrorToast t={t} error={response.error} />);
      } else {
        setProducts(response.data?.data || []);
      }
    });
  }, []);

  return products;
}
